const EXTERNAL_LINKS = {
  privacyPolicy: 'https://uw.co.uk/legal/privacy-customer',
  cookiesPolicy: 'https://uw.co.uk/legal/cookies-policy',
  termsAndConditions: 'https://uw.co.uk/legal/terms-conditions',
  termsCbcSection:
    'https://uw.co.uk/legal/terms-conditions#1srETQpfLmZkps0icpHDN7',
  faqsCbcSection: 'https://uw.co.uk/cashback-card#100tfBD7hX1KGiHyNkwAvF',
  termsMobileSection:
    'https://uw.co.uk/legal/terms-conditions#5bFcqM5NJjoWrFGQUA9nFQ',
  tariffInformation:
    'https://s3-eu-west-1.amazonaws.com/pdf.utilitywarehouse.co.uk/uw-residentialchargesbooklet-july2022-5-.pdf',
  smartMeterCTA: 'https://myaccount.uw.co.uk/energy/smart/register-interest',
  salesCallNumber: 'tel:03333280382',
  supportCallNumber: '0333 777 0777',
  appDownloadLink: 'https://uw.co.uk/mobile-app',
  contactOldBBProviderHelp:
    'https://help.uw.co.uk/article/broadband_and_landline/do-i-need-to-contact-my-current-provider',
  earlyTerminationRefundHelp:
    'https://help.uw.co.uk/article/account/help_to_switch/how-do-i-make-an-early-termination-claim-for-my-gbp400-to-help-switch-offer',
  chargesApply: 'https://uw.co.uk/legal/tariffs-charges',
  mobileCoverageChecker: 'https://uw.co.uk/mobile/network',
  overseasRoamingArticle:
    'https://help.uw.co.uk/article/mobile/mobile-roaming/how-much-will-it-cost-me-to-use-my-mobile-abroad',
  residentialTariffsAndCharges: 'https://uw.co.uk/legal/tariffs-charges',
  mobileFairUsePolicy:
    'https://assets.ctfassets.net/0sn9t583vfn4/2cdPOyC5ZulsbDdKLY0AL1/3c586a45b25247ed906339d2a902db20/UW_Residential_MobileFairUsePolicy_010224_v4__2_.pdf',
  earlyTerminationTerms:
    'https://help.uw.co.uk/article/account/help_to_switch/whats-the-gbp400-early-termination-fee-offer-to-help-me-switch',
  fibreTariffUrl: 'https://uw.link/fibre-connections',
  energyEVTariffs: 'https://uw.co.uk/energy/ev-tariffs',
  partnerJoin: 'https://uw.co.uk/partner/join',
  partnerFeedback:
    'https://docs.google.com/forms/d/e/1FAIpQLSe5HX5eWz3B53oIbUSTAUrQQIVGWtQPEJRMyniPBIt3oaUPxQ/viewform?usp=pp_url',
  tariffInformationLabels:
    'https://uw.co.uk/legal/terms-conditions/energy-tariff-information',
  bhcPromoTerms:
    'https://uw.co.uk/legal/terms-conditions/boiler-3month-free-2026',
} as const;

export { EXTERNAL_LINKS };
